import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Button, CloseButton } from '@instructure/ui-buttons';
import { Text } from '@instructure/ui-text';
import { Heading } from '@instructure/ui-heading';
import t from '@instructure/quiz-i18n/es/format-message';
import { ImportantModal, ModalHeader, ModalBody, ModalFooter, XSMALL_SIDE_MARGIN } from '@instructure/quiz-common';
export var ConfirmationModal = /*#__PURE__*/function (_Component) {
  function ConfirmationModal() {
    var _this;
    _classCallCheck(this, ConfirmationModal);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, ConfirmationModal, [].concat(args));
    _defineProperty(_this, "state", {
      action: null
    });
    _defineProperty(_this, "continueAction", function () {
      _this.setState({
        action: 'continue'
      }, _this.props.closeModal);
    });
    _defineProperty(_this, "cancelAction", function () {
      _this.setState({
        action: 'cancel'
      }, _this.props.closeModal);
    });
    _defineProperty(_this, "doAction", function () {
      var _this$props = _this.props,
        onContinue = _this$props.onContinue,
        onCancel = _this$props.onCancel;
      if (_this.state.action === 'continue') {
        onContinue && onContinue();
      } else if (_this.state.action === 'cancel') {
        onCancel && onCancel();
      }
      _this.setState({
        action: null
      });
    });
    return _this;
  }
  _inherits(ConfirmationModal, _Component);
  return _createClass(ConfirmationModal, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
        title = _this$props2.title,
        text = _this$props2.text,
        cancelText = _this$props2.cancelText,
        continueText = _this$props2.continueText,
        size = _this$props2.size,
        shouldReturnFocus = _this$props2.shouldReturnFocus,
        continueVariant = _this$props2.continueVariant,
        automationPrefix = _this$props2.automationPrefix;
      return /*#__PURE__*/React.createElement(ImportantModal, {
        open: this.props.modalOpen,
        size: size || 'small',
        label: title || t('Confirm'),
        onDismiss: this.cancelAction,
        "data-automation": automationPrefix ? "sdk-".concat(automationPrefix, "-confirmation-modal") : 'sdk-confirmation-modal',
        shouldReturnFocus: shouldReturnFocus,
        onClose: this.doAction
      }, /*#__PURE__*/React.createElement(ModalHeader, null, /*#__PURE__*/React.createElement(Heading, {
        level: "reset",
        as: "h2",
        "data-automation": automationPrefix ? "sdk-".concat(automationPrefix, "-confirmation-modal-heading") : 'sdk-confirmation-modal-heading'
      }, title || t('Confirm')), /*#__PURE__*/React.createElement(CloseButton, {
        onClick: this.cancelAction,
        placement: "end",
        offset: "medium",
        screenReaderLabel: t('Close')
      })), /*#__PURE__*/React.createElement(ModalBody, null, /*#__PURE__*/React.createElement(Text, {
        color: "primary"
      }, text || t('Are you sure?'))), /*#__PURE__*/React.createElement(ModalFooter, null, /*#__PURE__*/React.createElement(Button, {
        onClick: this.cancelAction,
        margin: XSMALL_SIDE_MARGIN,
        "data-automation": automationPrefix ? "sdk-".concat(automationPrefix, "-confirmation-modal-cancel") : 'sdk-confirmation-modal-cancel'
      }, cancelText || t('Cancel')), /*#__PURE__*/React.createElement(Button, {
        color: continueVariant || 'primary',
        onClick: this.continueAction,
        margin: XSMALL_SIDE_MARGIN,
        "data-automation": automationPrefix ? "sdk-".concat(automationPrefix, "-confirmation-modal-confirm") : 'sdk-confirmation-modal-confirm'
      }, continueText || t('Confirm'))));
    }
  }]);
}(Component);
_defineProperty(ConfirmationModal, "propTypes", {
  closeModal: PropTypes.func.isRequired,
  modalOpen: PropTypes.bool.isRequired,
  title: PropTypes.string,
  text: PropTypes.string,
  cancelText: PropTypes.string,
  continueText: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  continueVariant: PropTypes.string,
  size: PropTypes.string,
  shouldReturnFocus: PropTypes.bool,
  onContinue: PropTypes.func,
  onCancel: PropTypes.func,
  automationPrefix: PropTypes.string
});
_defineProperty(ConfirmationModal, "defaultProps", {
  title: null,
  text: null,
  cancelText: null,
  continueText: null,
  continueVariant: null,
  size: null,
  shouldReturnFocus: true,
  onContinue: null,
  onCancel: null,
  automationPrefix: null
});
export default ConfirmationModal;